import { useMemo } from 'react';

import { VFlex, VStack, cn, formatDate } from '@/package';

import type { NotificationItemProps } from './type';

const NotificationItem = ({ item, onClick }: NotificationItemProps) => {
  const formattedDate = useMemo(
    () => formatDate(item.createdAt),
    [item.createdAt],
  );
  const read = item.read;

  return (
    <VStack
      aria-label={`alarm-${item.id}`}
      className={cn('w-full px-6 py-4', {
        'hover:cursor-pointer hover:bg-Primary-Navy-Active': !read,
      })}
      gap={0.25}
      onClick={onClick}
    >
      <div
        className={cn('line-clamp-2 max-h-12', {
          'text-gray-400': read,
        })}
      >
        {item.content}
      </div>
      <VStack className="w-full">
        {item.emphasisText && (
          <div
            className={cn(
              'w-full overflow-hidden text-body-lg font-bold text-ellipsis whitespace-nowrap',
              {
                'text-blue-300': !read,
                'text-gray-300': read,
              },
            )}
          >
            {item.emphasisText}
          </div>
        )}
        {item.description && (
          <div
            className={cn(
              'w-full overflow-hidden text-body-lg text-ellipsis whitespace-nowrap',
              {
                'text-gray-500': !read,
                'text-gray-300': read,
              },
            )}
          >
            {item.description}
          </div>
        )}
      </VStack>
      <VFlex
        className={cn('w-full', {
          'text-gray-600': !read,
          'text-gray-400': read,
        })}
        justify="between"
        items="center"
      >
        <div>
          {item.from?.email ? (
            <div className="size-5 rounded-full bg-skyBlue-300 text-center text-body-sm">
              {item.from.email[0]}
            </div>
          ) : (
            <>&nbsp;</>
          )}
        </div>
        <VFlex items="center" gap={0.5}>
          <div className="text-body-md">{formattedDate}</div>
          {!item.read && (
            <div className="size-2 rounded-full bg-blue-300"></div>
          )}
        </VFlex>
      </VFlex>
    </VStack>
  );
};

export default NotificationItem;
